import { render, staticRenderFns } from "./contact-teacher.vue?vue&type=template&id=319d7d24&scoped=true&"
import script from "./contact-teacher.vue?vue&type=script&lang=js&"
export * from "./contact-teacher.vue?vue&type=script&lang=js&"
import style0 from "./contact-teacher.vue?vue&type=style&index=0&id=319d7d24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319d7d24",
  null
  
)

export default component.exports